export default "__VITE_ASSET__BKhWhOSc__"